import { PageComponentTagId } from '../../models';

export const PAGE_COMPONENTS = {
  COMPANY_BUSINESS_DESCRIPTION: 'company_business_description',
};

export enum OVERVIEW_TAB_WIDGET_ID {
  COMPANY_OVERVIEW = 'COMPANY_OVERVIEW',
  RISK_PRODUCT = 'RISK_PRODUCT',
  RECENTLY_PUBLISHED = 'RECENTLY_PUBLISHED',
  DEALS = 'DEALS',
  CS_VIEW = 'CS_VIEW',
  COMPANY_FIRST_SEGMENT = 'COMPANY_FIRST_SEGMENT',
  COMPANY_SECOND_SEGMENT = 'COMPANY_SECOND_SEGMENT',
}

export enum RISK_TAB_WIDGET_ID {
  COMPANY_OVERVIEW = 'COMPANY_OVERVIEW',
  RISK_PRODUCT = 'RISK_PRODUCT',
  RISK_OVERVIEW = 'RISK_OVERVIEW',
  CQS_SUMMARY = 'CQS_SUMMARY',
  FUNDAMENTALS = 'FUNDAMENTALS',
  CRE_SUMMARY = 'CRE_SUMMARY',
}

export enum Container {
  LEFT = 'leftSideWidgets',
  MIDDLE = 'middleWidgets',
  RIGHT = 'rightSideWidgets',
}

export interface CompanyWidgetsOrderConfig {
  leftSideWidgets: CompanyWidgetId[];
  middleWidgets: CompanyWidgetId[];
  rightSideWidgets: CompanyWidgetId[];
}

export type CompanyWidgetId = OVERVIEW_TAB_WIDGET_ID | RISK_TAB_WIDGET_ID | PageComponentTagId;

export const COMPANY_WIDGETS_KEY = 'CompanyWidgets';
